module.exports = __webpack_public_path__ + "assets/img/15a.8c6412a3.jpg";